/* Kontura accessories block (product page).
   Adds the checked accessory products as separate cart lines, then lets
   Dawn's <product-form> submit the lamp itself so the cart drawer renders
   the complete cart in one pass. */

if (!customElements.get('kontura-accessories')) {
  customElements.define(
    'kontura-accessories',
    class KonturaAccessories extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        if (!this.form) return;

        this.passthrough = false;
        this.onSubmit = this.onSubmit.bind(this);
        // Capture phase: runs before Dawn's own submit handler on the form.
        this.form.addEventListener('submit', this.onSubmit, true);

        /* Zubehoer mit mehreren Varianten, etwa die Stockhornkette in 88 und
           120 cm, hat eine Auswahl in der Kachel. Die gewaehlte Variante wird
           in den Wert der Checkbox geschrieben, von dort liest selectedItems. */
        this.onVariantChange = this.onVariantChange.bind(this);
        this.addEventListener('change', this.onVariantChange);
      }

      disconnectedCallback() {
        this.form?.removeEventListener('submit', this.onSubmit, true);
        this.removeEventListener('change', this.onVariantChange);
      }

      onVariantChange(event) {
        const select = event.target.closest('.kontura-accessories__variant');
        if (!select) return;

        const item = select.closest('.kontura-accessories__item');
        const checkbox = item?.querySelector('.kontura-accessories__checkbox');
        if (!checkbox) return;

        checkbox.value = select.value;

        const price = item.querySelector('.kontura-accessories__price');
        const chosen = select.options[select.selectedIndex];
        if (price && chosen?.dataset.price) price.textContent = chosen.dataset.price;
      }

      get selectedItems() {
        return Array.from(this.querySelectorAll('input[type="checkbox"]:checked')).map((input) => ({
          id: Number(input.value),
          quantity: 1,
        }));
      }

      onSubmit(event) {
        if (this.passthrough) {
          this.passthrough = false;
          return;
        }

        const items = this.selectedItems;
        if (items.length === 0) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        fetch(`${routes.cart_add_url}.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items }),
        })
          .catch(() => {
            /* Adding the lamp is the important part — never block it on the accessories. */
          })
          .finally(() => {
            this.passthrough = true;
            this.form.requestSubmit();
          });
      }
    }
  );
}
